export const ChainId = {
    ETHEREUM: 1,
    // ROPSTEN: 3,
    // RINKEBY: 4,
    GÖRLI: 5,
    // KOVAN: 42,
    POLYGON: 137,
    POLYGON_TESTNET: 80001,
    FANTOM: 250,
    FANTOM_TESTNET: 4002,
    GNOSIS: 100,
    BSC: 56,
    BSC_TESTNET: 97,
    ARBITRUM: 42161,
    ARBITRUM_NOVA: 42170,
    ARBITRUM_TESTNET: 421614,
    AVALANCHE: 43114,
    AVALANCHE_TESTNET: 43113,
    HECO: 128,
    // HECO_TESTNET: 256,
    HARMONY: 1666600000,
    // HARMONY_TESTNET: 1666700000,
    OKEX: 66,
    // OKEX_TESTNET: 65,
    CELO: 42220,
    PALM: 11297108109,
    MOONRIVER: 1285,
    FUSE: 122,
    TELOS: 40,
    MOONBEAM: 1284,
    OPTIMISM: 10,
    KAVA: 2222,
    METIS: 1088,
    BOBA: 288,
    BOBA_AVAX: 43288,
    BOBA_BNB: 56288,
    BTTC: 199,
    SEPOLIA: 11155111,
    // CONSENSUS_ZKEVM_TESTNET: 59140,
    // SCROLL_ALPHA_TESTNET: 534353,
    // BASE_TESTNET: 84531,
    POLYGON_ZKEVM: 1101,
    THUNDERCORE: 108,
    FILECOIN: 314,
    HAQQ: 11235,
    CORE: 1116,
    ZKSYNC_ERA: 324,
    LINEA: 59144,
    BASE: 8453,
    SCROLL: 534352,
    ZETACHAIN: 7000,
    CRONOS: 25,
    BLAST: 81457,
    SKALE_EUROPA: 2046399126,
    ROOTSTOCK: 30,
    MANTLE: 5000,
    // RONIN: 2020,
    CURTIS: 33111,
    MANTA: 169,
    MODE: 34443,
    TAIKO: 167000,
    ZKLINK: 810180,
    APE: 33139,
};
//# sourceMappingURL=id.js.map